/**
 * Shared helper for "touch to open" links: open the edit route when the user
 * has edit permission, otherwise open the read-only view route.
 */

export type PermissionAwareDetailLocation = {
	pathname: string;
	state?: { returnTo?: string };
};

export type PermissionAwareDetailOptions = {
	/** Route template containing `:id` (or another `:paramName`). */
	editPath: string;
	/** Route template containing `:id` (or another `:paramName`). */
	viewPath: string;
	canEdit: boolean;
	id: number | string;
	/** Path param token to replace. Defaults to `:id`. */
	paramName?: string;
	returnTo?: string;
};

export function getPermissionAwareDetailLocation({
	editPath,
	viewPath,
	canEdit,
	id,
	paramName = ':id',
	returnTo,
}: PermissionAwareDetailOptions): PermissionAwareDetailLocation {
	const template = canEdit ? editPath : viewPath;
	return {
		pathname: template.replace(paramName, String(id)),
		...(returnTo ? { state: { returnTo } } : {}),
	};
}
